export default __webpack_public_path__ + "static/media/trash.e51cf6d0.svg";